<template>
  <div class="search-home-page">
    <TopBanner />
    <div class="search-home-scroll">
      <div class="content">
        <div class="search-card">
          <div class="title">精准匹配——让客户拥有更低成本，让供应商赢得更公平</div>
          <SearchBar ref="searchBar" :category.sync="category" :keyword.sync="keyword" @category-open="handleCategoryOpen">
            <template #action>
              <el-button type="primary" class="search-btn" @click="handleSearch">立即查询</el-button>
            </template>
          </SearchBar>
        </div>

        <div class="recent-section">
          <div class="recent-label">最近搜索</div>
          <div class="tag-list">
            <div v-for="tag in recentTags" :key="tag" class="tag-item" @click="handleTagClick(tag)">
              {{ tag }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog top="8vh" :append-to-body="true" :visible.sync="showServiceDialog" width="580px" :show-close="false" :close-on-click-modal="true" custom-class="kehufuwu">
      <CustomerService @close="showServiceDialog = false" />
    </el-dialog>
  </div>
</template>

<script>
import TopBanner from "@/components/TopBanner.vue";
import SearchBar from "@/components/SearchBar.vue";
import CustomerService from "@/components/CustomerService.vue";

export default {
  name: "SearchHome",
  components: {
    TopBanner,
    SearchBar,
    CustomerService,
  },
  data() {
    return {
      category: "",
      keyword: "",
      recentTags: [],
      showServiceDialog: false,
      userRes: {},
    };
  },
  created() {
    this.loadRecentTags();
    try {
      this.userRes = JSON.parse(localStorage.getItem("userRes")) || {};
    } catch (e) {
      this.userRes = {};
    }
  },
  methods: {
    loadRecentTags() {
      const stored = localStorage.getItem("recentSearches");
      if (stored) {
        try {
          this.recentTags = JSON.parse(stored);
        } catch (e) {
          this.recentTags = [];
        }
      }
    },
    handleSearch() {
      if (!this.category) {
        this.$message.warning("请选择分类");
        return;
      }
      if (String(this.userRes?.accountLevel) != "1") {
        this.showServiceDialog = true;
        return;
      }
      console.log("搜索", this.category, this.keyword);
      // 始终保存搜索数据到 localStorage，供 SearchResult 页面读取
      localStorage.setItem(
        "supplierSearchData",
        JSON.stringify({
          category: this.category,
          keyword: this.keyword.trim(),
        })
      );
      if (this.keyword && this.keyword.trim()) {
        const trimmed = this.keyword.trim();
        this.recentTags = this.recentTags.filter((tag) => tag !== trimmed);
        this.recentTags.unshift(trimmed);
        if (this.recentTags.length > 6) {
          this.recentTags = this.recentTags.slice(0, 6);
        }
        localStorage.setItem("recentSearches", JSON.stringify(this.recentTags));
      }
      this.$router.push({
        path: "/search-result",
      });
    },
    handleCategoryOpen() {
      if (String(this.userRes?.accountLevel) != "1") {
        // 关闭已展开的下拉框
        if (this.$refs.searchBar && this.$refs.searchBar.$refs.categorySelect) {
          this.$refs.searchBar.$refs.categorySelect.visible = false;
        }
        this.showServiceDialog = true;
      }
    },
    handleTagClick(tag) {
      if (!this.category) {
        this.$message.warning("请选择分类");
        return;
      }
      if (String(this.userRes?.accountLevel) != "1") {
        this.showServiceDialog = true;
        return;
      }
      this.keyword = tag;
      this.handleSearch();
    },
  },
};
</script>

<style scoped>
.search-home-page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #f0f4fa;
}

.search-home-scroll {
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.content {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 170px;
}

.search-card {
  background: linear-gradient(0deg, #f4f5f8 0%, #fefefe 100%);
  border-radius: 9px;
  padding: 32px 48px;
  box-shadow: 0px 16px 32px 0px rgba(210, 217, 236, 0.3);
  border: 4px solid #ffffff;
}

.title {
  font-size: 26px;
  font-weight: 500;
  letter-spacing: 4px;
  color: #333333;
  text-align: center;
  margin-bottom: 24px;
}

.search-btn {
  width: 150px;
  height: 52px;
  margin-left: 12px;
  background: linear-gradient(270deg, #ff9318 0%, #ff6b35 100%);
  border: none;
  border-radius: 9px;
  font-size: 19px;
}

.search-btn:hover,
.search-btn:focus {
  background-color: #e66d00;
  border-color: #e66d00;
}

.recent-section {
  margin-top: 42px;
}

.recent-label {
  font-size: 18px;
  color: #333333;
  margin-bottom: 10px;
  font-weight: 500;
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.tag-item {
  padding: 11px 24px;
  background: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 100px;
  font-size: 16px;
  color: #666666;
  cursor: pointer;
  transition: all 0.2s;
}

.tag-item:hover {
  /* color: #409eff; */
  border-color: #68adf1;
}
</style>
